import request from '@/utils/request'

/**
 * 查询秒杀订单列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryAdminSeckillOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productSeckill.queryAdminSeckillOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}